import setFieldValue from "@iewc/Store/Handlers/InstantRegistrationForm/SetFieldValue";
import { CustomActions, CustomState } from "@iewc/Store/Reducers";
import {
    OwnProps,
    setInstantFormEffects,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewc/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    instantRegLastName: state.customInstantRegistrationForm.fieldValues.instantRegLastName,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const InstantRegLastNameWidget: React.FC<Props> = ({ instantRegLastName, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Instant Last Name");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setInstantFormEffects(isRequired, instantRegLastName, "instantRegLastName", () =>
        validateFieldBy(isRequired, label, instantRegLastName, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "instantRegLastName", value: event.target.value });
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={instantRegLastName || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(InstantRegLastNameWidget);
